export default "__VITE_ASSET__50b1a67d__"